export default __webpack_public_path__ + "static/media/05.ea75f62a.svg";